import { TabbedShowLayout } from "react-admin";
import { Divider } from "@mui/material";
import React from "react";

const TabbedShowLayoutMod = (props) => {
  return <TabbedShowLayout {...props} divider={<Divider flexItem />} />;
};

export default TabbedShowLayoutMod;
